import { inject, Injectable } from '@angular/core';
import { Observable, of, switchMap, throwError } from 'rxjs';
import {
  DashboardPreference,
  DashboardPreferenceParams,
} from '@ps/user-settings-models';
import { DashboardApi } from '../api/dashboard.api';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private readonly _api = inject(DashboardApi);

  public getPreferences(
    params: DashboardPreferenceParams,
  ): Observable<DashboardPreference[]> {
    return this._api.getPreferences(params);
  }

  public updatePreferences(
    preferences: DashboardPreference[],
  ): Observable<boolean> {
    return this._api.updatePreferences(preferences).pipe(
      switchMap(({ status }) => {
        if (status !== 'success') {
          return throwError(
            () => new Error('Failed to update dashboard preferences'),
          );
        }
        return of(true);
      }),
    );
  }
}
